import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

/**
 * Which PandaDoc template this deal's contract would be built from.
 *
 * Asked of the server rather than worked out here. The resolution reads the
 * org's `contractTemplates`, its parent's, and the type-to-template maps, and
 * the server answers with the same function the creation path calls. A copy in
 * the browser would be one more thing to drift, and drift is the whole reason
 * this exists: until now nobody could see which paper a deal was about to use
 * until after a client had signed it.
 */

export interface TemplateForDeal {
  templateId: string | null
  templateName: string | null
  /** Where the choice came from. */
  source: 'organization' | 'parent organization' | 'default'
  isOverride: boolean
  mode: 'signature' | 'noSignature'
  type: string | null
}

export const useTemplateForDeal = (PK?: string, dealUuid?: string) => {
  return useQuery({
    queryKey: ['pandadocTemplateForDeal', PK, dealUuid],
    enabled: Boolean(PK && dealUuid),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    queryFn: async (): Promise<TemplateForDeal> => {
      const { data } = await axios.get<TemplateForDeal>(
        `${baseUrl}/aws/pandadoc/template-for-deal/${encodeURIComponent(PK)}/${encodeURIComponent(dealUuid)}`,
      )
      return data
    },
  })
}
